export default __webpack_public_path__ + "static/media/CrownThinning.6433d89e.jpg";